var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement(
      "title",
      null,
      "Last"
    ),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.94 17.89h-1.5a1 1 0 0 1-1-1V3.23a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v13.66a1 1 0 0 1-1 1zm-4.44-7.13a1 1 0 0 0 0-1.52l-6-5.16a1 1 0 0 0-1.65.76v3.41H1.06a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h5.78v3.41a1 1 0 0 0 1.65.76z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Last.svg